export const SITE_CONFIG = {
  platform_name: "Tykkit",
  platform_tagline: "Jahan Event, Wahan Hum",
  platform_url:
    process.env.NEXT_PUBLIC_WEBSITE_URL?.replace(/\/$/, "") ||
    process.env.NEXT_PUBLIC_CUSTOMER_URL?.replace(/\/$/, "") ||
    "",
  company_name: "TYKKIT ENTERTAINMENT PRIVATE LIMITED",
  support_email: "vibe@tykkit.com",
  support_phone: "+91 73 200 79 200",
  whatsapp_number: "+91 73 200 79 200",
  android_app_url:
    process.env.NEXT_PUBLIC_ANDROID_STORE_LINK ||
    process.env.NEXT_PUBLIC_MOBILE_APP ||
    "",
  ios_app_url: "",

  contact_email: "vibe@tykkit.com",
  contact_phone: " 079 4601 9868",
  office_address:
    "A405, Ganesh Glory 11\noff S.G. Highway\nAhmedabad, Gujarat 382470\nIndia",
  facebook_url: "https://www.facebook.com/tykkitverse",
  instagram_url: "https://www.instagram.com/tykkitverse",
  twitter_url: "https://x.com/tykkitverse",
  youtube_url: "",
  linkedin_url: "https://www.linkedin.com/company/tykkitverse",

  effective_date: "",
  last_updated_date: "",
  jurisdiction: "Ahmedabad, Gujarat, India",
};
